/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Close } from "@mui/icons-material";
import { Alert } from "@mui/material";

import clsx from "clsx";
import { formatDistanceToNow } from "date-fns";

import KTOffcanvas from "_metronic/_assets/js/offcanvas";

import { toSafeRichHtml } from "app/common/utils/rich-text";
import {
  clearNotifications,
  deleteNotification,
  flagNames,
  loadNotifications,
  markNotificationsAsRead,
} from "app/store/modules/actions/notifications.actions";
import { getFlags } from "app/store/modules/selectors/common.selector";
const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

function NotificationsList({
  loading,
  error,
  notifications,
  totalCount,
  onLoadMore,
  onDelete,
  markRead,
}) {
  return (
    <div className="kt-quick-panel__content pt-0">
      <div
        className="px-4 text-right text-primary cursor-pointer"
        onClick={() => {
          const notificationIds = notifications.map(({ _id }) => _id);
          markRead(notificationIds);
        }}
      >
        <FormattedMessage id="APP.NOTIFICATIONS.MARK_ALL_READ" />
      </div>

      {!!error && (
        <div className="d-flex justify-content-center mt-2">
          <Alert severity="error">{error}</Alert>
        </div>
      )}

      <PerfectScrollbar
        options={perfectScrollbarOptions}
        style={{
          maxHeight: "calc(100vh - 100px)",
          position: "relative",
        }}
      >
        <div className="kt-notification">
          {notifications.map((notification) => {
            return (
              <Link
                onClick={() => markRead([notification._id], true)}
                to={notification.url}
                key={notification._id}
                className={`kt-notification__item ${clsx({
                  unread: !notification.hasRead,
                })}`}
              >
                <div className="kt-notification__item-details">
                  <div className="d-flex align-items-center w-100">
                    <div className="flex-grow-1">
                      <div className="kt-notification__item-title">{notification.title}</div>
                    </div>
                    <div
                      className="text-dark"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onDelete(notification._id);
                      }}
                    >
                      <Close fontSize="inherit" />
                    </div>
                  </div>
                  <div
                    className="kt-notification__item-description"
                    dangerouslySetInnerHTML={{ __html: toSafeRichHtml(notification.description) }}
                  />
                  <div className="kt-notification__item-time">
                    {formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true })}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {!loading && !error && notifications.length < totalCount && (
          <div
            className="mt-1 text-center text-primary cursor-pointer"
            onClick={() => onLoadMore()}
          >
            <FormattedMessage id="APP.NOTIFICATIONS.LOAD_MORE" />
          </div>
        )}
      </PerfectScrollbar>

      {loading && (
        <div className="mt-15 kt-spinner kt-spinner--center kt-spinner--md kt-spinner--brand"></div>
      )}
    </div>
  );
}

export default function QuickPanel() {
  const dispatch = useDispatch();

  const flags = useSelector(getFlags);
  const notifications = useSelector((store) => store.notifications);

  const offCanvas = useRef(null);

  const loading = flags.loading[flagNames.LOADING_NOTIFICATIONS];
  const error = flags.error[flagNames.LOADING_NOTIFICATIONS];

  useEffect(() => {
    // eslint-disable-next-line
    const panel = document.getElementById("kt_notification_list_panel");

    // eslint-disable-next-line
    offCanvas.current = new KTOffcanvas(panel, {
      overlay: true,
      baseClass: "kt-quick-panel",
      closeBy: "kt_notification_list_panel_close_btn",
      toggleBy: ["kt_notification_list_toggler_btn", "kt_notification_list_toggler_btn_mobile"],
    });

    offCanvas.current.on("afterHide", () => {
      dispatch(clearNotifications());
    });

    offCanvas.current.on("beforeShow", () => {
      dispatch(loadNotifications());
    });
  }, [dispatch]);

  return (
    <div id="kt_notification_list_panel" className="kt-quick-panel">
      <div className="d-flex justify-content-between align-items-center p-4">
        <div>
          <h3 className="m-0">
            <FormattedMessage id="APP.NOTIFICATIONS.TITLE" />
          </h3>
        </div>
        <div>
          <span className="cursor-pointer" id="kt_notification_list_panel_close_btn">
            <Close sx={{ fontSize: "2em" }} />
          </span>
        </div>
      </div>

      <NotificationsList
        loading={loading}
        error={error}
        notifications={notifications.list}
        totalCount={notifications.total}
        onDelete={(notificationId) => dispatch(deleteNotification(notificationId))}
        markRead={(notificationIds, shouldHideSidebar) => {
          dispatch(markNotificationsAsRead(notificationIds));

          if (shouldHideSidebar) {
            offCanvas.current.hide();
          }
        }}
        onLoadMore={() => dispatch(loadNotifications())}
      />
    </div>
  );
}
